
import { equals, defaultOf } from "./fable_modules/fable-library-js.5.3.0/Util.js";
import { ClientTypes_ThemePreference } from "./Shared/ClientTypes.js";

const storageKey = "you-thon-theme";

export function load() {
    const matchValue = localStorage.getItem(storageKey);
    if (matchValue === defaultOf()) {
        return new ClientTypes_ThemePreference(2, []);
    }
    else {
        switch (matchValue) {
            case "light":
                return new ClientTypes_ThemePreference(0, []);
            case "dark":
                return new ClientTypes_ThemePreference(1, []);
            default:
                return new ClientTypes_ThemePreference(2, []);
        }
    }
}

function prefersDark() {
    return matchMedia('(prefers-color-scheme: dark)').matches;
}

export function apply(pref) {
    if ((pref.tag === 0) ? false : ((pref.tag === 2) ? prefersDark() : true)) {
        document.documentElement.classList.add("dark");
    }
    else {
        document.documentElement.classList.remove("dark");
    }
    switch (pref.tag) {
        case 0: {
            localStorage.setItem(storageKey, "light");
            break;
        }
        case 1: {
            localStorage.setItem(storageKey, "dark");
            break;
        }
        default:
            localStorage.removeItem(storageKey);
    }
}

/**
 * Register a listener for OS color scheme changes. Only reacts when the user preference is System.
 */
export function listenForOsChanges() {
    return matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (() => {
        if (equals(load(), new ClientTypes_ThemePreference(2, []))) {
            apply(new ClientTypes_ThemePreference(2, []));
        }
    }));
}

//# sourceMappingURL=ThemeManager.js.map
